export default __webpack_public_path__ + "e4a3668c3d469a3f3a45c3ce36858b5e.webp";